import React, { useState } from 'react';
import { useBallparkContext } from '@marvelapp/marvel-3-application';
import CenteredLoader from '../CenteredLoader';
import { Modal } from '../Modal';
import Page from '../Page';
import InviteUsers from './InviteUsers';
export default function InviteUsersModal({ billingCycle, closeLink = '..', entity, guestCount, inviteUsers, isFetchingQuantity, pricePerUser, seatsUsed, seatsLimit, seatsOriginallyPurchased, seatsExpandable, }) {
    const isBallpark = useBallparkContext();
    const [isSendingInvite, setIsSendingInvite] = useState(false);
    if (isFetchingQuantity) {
        return React.createElement(CenteredLoader, null);
    }
    return (React.createElement(Page, { title: "Invite people" },
        React.createElement(Modal, { closeLink: closeLink, maxWidth: 600 },
            React.createElement(InviteUsers, { billingCycle: billingCycle, buttonIsLoading: isSendingInvite, entity: entity, guestCount: guestCount, onInviteUsers: ({ emails, role, setEmails, setShowFormError }) => {
                    setIsSendingInvite(true);
                    inviteUsers({
                        setEmails,
                        setIsSendingInvite,
                        setShowFormError,
                        usersToInvite: { emails, role },
                    });
                }, pricePerUser: pricePerUser, seatsExpandable: seatsExpandable || isBallpark, seatsLimit: seatsLimit, seatsOriginallyPurchased: seatsOriginallyPurchased, seatsUsed: seatsUsed }))));
}
